import React, { FC } from 'react';

interface ImageCardInterface {
  src: string;
  colorBackground?: string;
  alt?: string;
}

const ImageCard: FC<ImageCardInterface> = ({ src, colorBackground, alt }) => {
  return (
    <div>
      <div
        className="relative overflow-hidden w-[332px] h-[14.5rem] mb-6 rounded-[20px_20px_20px_320px]"
        style={{ background: colorBackground || '#DBDCDC' }}
      >
        <div className="flex justify-end">
          <img src={src} alt={alt} className="w-[180px] pt-[15%] pr-[10%]" />
        </div>
        <div
          className="absolute inset-0 rounded-[20px_20px_20px_320px]"
          style={{ background: colorBackground || '#DBDCDC', mixBlendMode: 'saturation' }}
        />
      </div>
    </div>
  );
};

export default ImageCard;
